import { usePermission } from "../../../hooks/usePermission";

const PermissionGate = ({ module, action = "view", children, fallback = null }) => {
  const { hasPermission, isSuperAdmin } = usePermission();

  if (isSuperAdmin || hasPermission(module, action)) {
    return children;
  }

  return fallback;
};

export default PermissionGate;
